import React from "react";
import {
  lifecycle,
  compose,
  branch,
  renderNothing,
  renderComponent,
  withProps,
  setDisplayName,
  defaultProps
} from "recompose";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actions } from "../../modules/customers";
import TryAgain from "../../components/TryAgain";
import Loading from "../../components/Loading";
import { objectToQueryString } from "../../helpers";

const failed = ({ failureFetchCustomers }) => failureFetchCustomers;
const isFetching = ({ loadingFetchCustomers }) => loadingFetchCustomers;
const isInitial = ({
  failureFetchCustomers,
  loadingFetchCustomers,
  successFetchCustomers,
  customers
}) =>
  !failureFetchCustomers &&
  !loadingFetchCustomers &&
  !successFetchCustomers &&
  !customers;
const hasNoCustomers = ({ customers, loadingFetchCustomers }) =>
  !customers && !loadingFetchCustomers;

const fetchCustomersCallback = ({
  currentDealer,
  fetchCustomers,
  role,
  user,
  fetchOnInit
}) => () => {
  if (user && fetchOnInit) {
    role === "staff" &&
      fetchCustomers({
        dealer_id: currentDealer.id,
        query_string: objectToQueryString({ page: 1, per_page: 10 })
      });
  }
};

const TryAgainCustomer = ({ failureFetchCustomers, ...props }) => (
  <TryAgain
    label={failureFetchCustomers}
    onTryAgain={fetchCustomersCallback(props)}
  />
);

const nonOptimalStates = states =>
  compose(...states.map(state => branch(state.when, state.render)));

const withLifeCycle = lifecycle({
  componentDidMount() {
    fetchCustomersCallback(this.props)();
  },
  componentWillUnmount() {
    this.props.resetState(["customers", "currentCustomer"]);
  }
});

const mapStateToProps = state => ({
  ...(state.customers || {}),
  currentDealer: state.dealers.currentDealer,
  role: state.settings.role,
  user: state.auth.user
});
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(actions, dispatch),
  dispatch
});

export default compose(
  setDisplayName("WithFetchCustomers"),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  defaultProps({
    fetchOnInit: true
  }),
  withLifeCycle,
  nonOptimalStates([
    {
      when: isFetching,
      render: renderComponent(
        withProps({ label: "Loading Customers" })(Loading)
      )
    },
    { when: failed, render: renderComponent(TryAgainCustomer) },
    { when: isInitial, render: renderNothing },
    { when: hasNoCustomers, render: renderNothing }
  ])
);
